const EXCLUDED_RECORDED_RESPONSE_ADMINS = new Set([
    'prescott blackler',
])

const normalizeAdminName = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')

export const filterRecordedResponseRows = (rows) => (
    Array.isArray(rows)
        ? rows.filter((row) => (
            !EXCLUDED_RECORDED_RESPONSE_ADMINS.has(
                normalizeAdminName(row?.responseActorName)
            )
        ))
        : []
)
